module.exports = __webpack_public_path__ + "img/synchronstar.62b27c37.png";